export class Logger {
  static info(info = '') {
    console.info(
      `%c[rentgrata] - ${info.toString()}`,
      'color: #49d0d4; font-size: small'
    );
  }

  static error(message) {
    console.error(
      `%c[rentgrata] - ${message?.toString?.()}`,
      'color: red; font-size: small'
    );
  }
}
